<template>
  <div class="a-dash-widgets">
    <div class="__toolbar">
      <v-btn small rounded @click="refreshAll">
        <v-icon left>mdi-refresh</v-icon>
        {{ $t("_.refresh") }}
      </v-btn>

      <template v-if="measure">
        <v-btn small rounded color="primary" @click="clearMap">
          <v-icon left>mdi-close</v-icon>
          {{ $t(`map.${measure}`) }}
        </v-btn>
      </template>
    </div>

    <v-spacer></v-spacer>

    <div class="__swiper">
      <swiper
        ref="swiperRef"
        :options="{
          slidesPerView: 'auto',
          spaceBetween: 4 * 4,
          autoHeight: true,
          preventClicks: false,
          preventClicksPropagation: false,
          preventInteractionOnTransition: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }"
      >
        <swiper-slide v-for="(item, index) in widgetsComponents" :key="index">
          <component ref="widgetsRef" :is="item.component"></component>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import { inject, ref } from "vue-demi";
import { useIntervalFn } from "@vueuse/shared";

import CustomerWidget from "@/components/Widgets/CustomerWidget.vue";
import TurnoverWidget from "@/components/Widgets/TurnoverWidget.vue";
import DeliveryRateWidget from "@/components/Widgets/DeliveryRateWidget.vue";
import PotentialWidgetVue from "@/components/Widgets/PotentialWidget.vue";
import DeliveryLooseWidgetVue from "@/components/Widgets/DeliveryLooseWidget.vue";
import RatingWidgetVue from "@/components/Widgets/RatingWidget.vue";
import TurnoverGraphWidget from "@/components/Widgets/TurnoverGraphWidget.vue";
import PromotionWidgetVue from "@/components/Widgets/PromotionWidget.vue";

export default {
  setup() {
    const widgetsRef = ref([]);
    const swiperRef = ref(null);

    const measure = inject("measure");
    const clearMap = inject("clearMap");

    const widgetsComponents = ref([
      { component: CustomerWidget },
      { component: PotentialWidgetVue },
      { component: DeliveryRateWidget },
      { component: DeliveryLooseWidgetVue },
      { component: TurnoverWidget },
      { component: TurnoverGraphWidget },
      { component: RatingWidgetVue },
      { component: PromotionWidgetVue }
    ]);

    const refreshAll = () => {
      widgetsRef.value.forEach(w => w.refresh());
    };

    useIntervalFn(refreshAll, 1000 * 60 * 1);

    return {
      widgetsComponents,
      widgetsRef,
      swiperRef,
      measure,

      clearMap,
      refreshAll
    };
  }
};
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables";

.a-dash-widgets {
  --widgets-gap: calc(4px * 4);
  --widgets-count: 1;
  --widgets-width: 100%;
  --widgets-padding: calc(4px * 3);

  @media (min-width: 1000px) {
    --widgets-count: 2;
    --widgets-width: calc(100% / var(--widgets-count) - var(--widgets-gap));
  }

  @media (min-width: 1300px) {
    --widgets-count: 3;
    --widgets-padding: calc(4px * 1);
  }

  @media (min-width: 1600px) {
    --widgets-count: 4;
  }

  position: fixed;
  inset: var(--widgets-padding);
  z-index: 402;
  pointer-events: none;

  display: flex;
  flex-direction: column;

  .__toolbar {
    display: flex;
    gap: 4px * 2;

    > * {
      pointer-events: all;
    }
  }

  .__swiper {
    position: relative;
    pointer-events: all;

    .swiper-slide {
      padding-bottom: 4px;
      width: var(--widgets-width);
      height: 100%;

      > .v-card {
        height: 100%;
      }
    }
  }
}
</style>
